import { render, staticRenderFns } from "./BrokerList.vue?vue&type=template&id=7a352864&scoped=true"
import script from "./BrokerList.vue?vue&type=script&lang=js"
export * from "./BrokerList.vue?vue&type=script&lang=js"
import style0 from "./BrokerList.vue?vue&type=style&index=0&id=7a352864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a352864",
  null
  
)

export default component.exports